const MENU = [
  {
    id: 0,
    index: "0",
    title: "首页",
    icon: "icon-order",
  },
  {
    id: 1,
    index: "1",
    title: "会员管理",
    icon: "icon-order",
    children: [
      {
        id: 1,
        index: "1-1",
        title: "会员列表"
      },
      {
        id: 2,
        index: "1-2",
        title: "会员申请审批"
      }
    ]
  },  {
    id: 2,
    index: "2",
    title: "文库管理",
    icon: "icon-order",
    children: [
      {
        id: 3,
        index: "2-1",
        title: "栏目管理"
      },
      {
        id: 4,
        index: "2-2",
        title: "期刊管理",
      },
      {
        id: 5,
        index: "2-3",
        title: "文章管理"
      }
    ]
  },{
    id: 3,
    index: "3",
    title: "系统管理",
    icon: "icon-order",
    children: [
      {
        id: 6,
        index: "3-1",
        title: "用户管理"
      },
      {
        id: 7,
        index: "3-2",
        title: "角色管理"
      },
      {
        id: 8,
        index: "3-3",
        title: "权限管理"
      },
      {
        id: 9,
        index: "3-4",
        title: "字典管理"
      },
      {
        id: 10,
        index: "3-5",
        title: "登录日志"
      }
    ]
  },
];

export default MENU;
